import { render, staticRenderFns } from "./adminboard.vue?vue&type=template&id=ab387df8&scoped=true&"
import script from "./adminboard.vue?vue&type=script&lang=js&"
export * from "./adminboard.vue?vue&type=script&lang=js&"
import style0 from "./adminboard.vue?vue&type=style&index=0&id=ab387df8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab387df8",
  null
  
)

export default component.exports